import { render, staticRenderFns } from "./DeliverablesField.vue?vue&type=template&id=23be7a21&scoped=true"
import script from "./DeliverablesField.vue?vue&type=script&lang=js"
export * from "./DeliverablesField.vue?vue&type=script&lang=js"
import style0 from "./DeliverablesField.vue?vue&type=style&index=0&id=23be7a21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be7a21",
  null
  
)

export default component.exports